import fetch from '../fetch';

export const FETCH_BILLING_ELIGIBILITY = 'FETCH_BILLING_ELIGIBILITY';
export const BILLING_ELIGIBILITY_FETCHED = 'BILLING_ELIGIBILITY_FETCHED';
export const BILLING_ELIGIBILITY_FETCH_FAILED = 'BILLING_ELIGIBILITY_FETCH_FAILED';
export const CLEAR_BILLING_ELIGIBILITY_DATA = 'CLEAR_BILLING_ELIGIBILITY_DATA';

const endpoint = '/billingsubscriptions/subscription/billdate/eligibility';

export default () => async dispatch => {
  dispatch({ type: FETCH_BILLING_ELIGIBILITY });

  const fetched = {
    type: BILLING_ELIGIBILITY_FETCHED,
    payload: {},
  };

  try {
    const billingEligibility = await dispatch(fetch(endpoint));
    fetched.payload = { ...billingEligibility.data[0] };
  } catch (error) {
    fetched.error = true;
    fetched.payload = error;
    dispatch({ type: BILLING_ELIGIBILITY_FETCH_FAILED });
  }

  dispatch(fetched);
};

export const clearBillingEligibilityData = () => ({
  type: CLEAR_BILLING_ELIGIBILITY_DATA,
});
